<fa-icon
  *ngIf="ikon"
  [icon]="ikon"
  [ngClass]="{ fa_ikon: textContent, ikon_right: ikonPos === 'right' }"
  [ngStyle]="{ '--size': ikonSize }"></fa-icon>
<ng-content></ng-content>
